import { Breadcrumb, Button, Form, Input, Layout } from "antd"
import { ApiLogBoundary } from "./boundary"
import { LayoutPageContent, LayoutPageHeader } from "components"
import { FileSearchOutlined } from "@ant-design/icons"
import { RouteComponentProps } from "react-router-dom"
import { StaticContext } from "react-router"
import { ApiLogTable } from "./views/ApiLogTable"
import { useEffect } from "react"

type Props = RouteComponentProps<
  {
    entityID: string
  },
  StaticContext,
  {
    data?: string
  }
>

export const ApiLogs: React.FC<Props> = (props) => {
  const [form] = Form.useForm()

  const handleSubmit = () => {
    const entityID = form.getFieldValue("entityID")
    props.history.push(`/api-logs/${entityID}`)
  }

  useEffect(() => {
    form.setFieldsValue({ entityID: props.match.params.entityID })
  }, [props.match.params.entityID, form])

  return (
    <ApiLogBoundary>
      <Layout>
        <LayoutPageHeader
          ghost={false}
          breadcrumb={
            <Breadcrumb>
              <Breadcrumb.Item key="/api-logs">
                <FileSearchOutlined />
                &nbsp;Api Logs
              </Breadcrumb.Item>
            </Breadcrumb>
          }
          title="Api Logs"
        />
        <LayoutPageContent
          transparent
          style={{ width: "100%", minWidth: "100%" }}
        >
          <div style={{ width: "33%" }}>
            <Form form={form} onFinish={handleSubmit} layout="horizontal">
              <h3>Search by Entity ID to find associated API Logs</h3>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Form.Item name="entityID" style={{ flex: 1 }}>
                  <Input type="text" placeholder="Enter Entity ID" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
          <ApiLogTable entityID={props.match.params.entityID} />
        </LayoutPageContent>
      </Layout>
    </ApiLogBoundary>
  )
}
